<ul class="nav nav-tabs mb-3">
  @for (tab of uiTabs | keyvalue; track tab) {
    <li class="nav-item" (click)="changeTab(tab.value)">
      <a class="nav-link" [class.active]="selectedTab === tab.value">{{
        tab.value
      }}</a>
    </li>
  }
</ul>
@for (tab of uiTabs | keyvalue; track tab) {
  <div class="tab-content">
    @if (selectedTab === tab.value) {
      <div
        class="tab-pane"
        [ngClass]="selectedTab === tab.value ? 'active' : ''"
      >
        @if (totalEventCount) {
          <div [ngClass]="tabClass?.[tab.key]" class="mb-3">
            @if (selectedTab == uiTabs.tab1) {
              <ng-template *ngTemplateOutlet="jobListTemplateRef"></ng-template>
            }
            @if (selectedTab == uiTabs.tab2) {
              <ng-template
                *ngTemplateOutlet="invoiceListTemplateRef"
              ></ng-template>
            }
            @if (selectedTab == uiTabs.tab3) {
              <ng-template
                *ngTemplateOutlet="invoiceListTemplateRef"
              ></ng-template>
            }
            @if (selectedTab == uiTabs.tab4) {
              <ng-template *ngTemplateOutlet="jobListTemplateRef"></ng-template>
            }
          </div>
        }
        @if (!totalRowsEvent && totalEventCount) {
          <div class="mt-5">
            <div class="alert alert-warning" role="alert">
              No Records Match Your Search Criteria
            </div>
          </div>
        }
      </div>
    }
  </div>
}
<ng-template #jobListTemplateRef>
  <div class="row row-cols-1 row-cols-lg-4 col-lg-6 mb-3">
    <div class="col">
      <gtapp-auto-complete
        [data]="clientDropDownList"
        placeHolder="Select Client"
        searchKeyword="company_name"
        [itemTemplate]="clientLookupTemplate"
        (inputChanged)="onClientSearch($event)"
        [initialValue]="selectedClient?.company_name"
        (selected)="onClientSelect($event)"
        [enableCloseOption]="true"
        inputId="clientLookupId"
        (fieldCleared)="editField('client')"
        (inputFocused)="inputFocused('client')"
      >
      </gtapp-auto-complete>
      <ng-template #clientLookupTemplate let-item>
        <div>
          {{ item?.company_name }}
        </div>
      </ng-template>
    </div>

    @if (totalEventCount > 4) {
      <div class="col">
        <select
          class="form-select form-select py-3"
          role="button"
          [ngModel]="selectedJobTypeId"
          (change)="onJobTypeFilterSelect($event)"
        >
          <option [value]="''" class="fw-bold">All Job Types</option>
          @for (jType of jobTypesDataList; track $index) {
            <option [value]="jType.id">
              {{ jType?.name }}
            </option>
          }
        </select>

        <!-- <div class="input-group">
          <div class="form-floating">
            <input
              type="text"
              [(ngModel)]="eventSearchStr"
              placeholder="Filter Jobs"
              class="form-control"
              (input)="filterEvents()"
            />
            <label>Filter Jobs</label>
          </div>
          @if (eventSearchStr) {
            <span
              class="input-group-text"
              (click)="eventSearchStr = ''; filterEvents()"
            >
              <i class="fa-solid fa-xmark"></i>
            </span>
          }
        </div> -->
      </div>
    }
    <div class="col form-floating" (click)="openRangePicker()">
      <input
        class="form-control input-font-sm"
        readonly
        placeholder="Date Filter"
        [value]="dateRangeValue"
      />
      <label for="">Date Filter</label>
    </div>
    @if (hasAppliedAnyFilter) {
      <div class="col" [ngClass]="largeView ? '' : 'text-end'">
        <button
          (click)="resetAndFetchLatestData()"
          class="btn btn-lg btn-danger d-flex align-items-center gap-2"
        >
          <i class="fa-solid fa-xmark fa-2x"></i>
          Reset Filters
        </button>
      </div>
    }
  </div>

  @if (
    tabEventDataList?.length > 1 &&
    [uiTabs.tab1, uiTabs.tab2, uiTabs.tab4].includes(selectedTab)
  ) {
    <div>
      <div class="mb-3 d-flex gap-3 p-2 text-primary align-items-center">
        <input
          class="form-check-input"
          type="checkbox"
          [checked]="allEventsSelected"
          (change)="selectAllEvents($event)"
          id="selectAllBox"
        />
        <label for="selectAllBox" class="mt-1"
          >Select All [{{ tabEventDataList?.length }}]</label
        >
        @if (selectedEventIds?.length) {
          <span class="col">
            <ng-template *ngTemplateOutlet="changeStatusTemplate"></ng-template>
          </span>
        }
      </div>
    </div>
  }
  @if (tabEventDataList?.length) {
    <div class="d-none d-lg-block">
      <div
        class="row row-cols-1 row-cols-lg-5 align-items-center text-secondary fw-semibold mb-3"
      >
        <div class="col-lg-2 text-center">
          <div class="d-flex m-0">
            <div class="flex-grow-1">Completed</div>
            <div class="mx-2" (click)="sortField(tableColumns['col1'])">
              <i class="fa-solid fa-sort"></i>
            </div>
          </div>
        </div>
        <div class="d-flex">
          <div class="flex-grow-1">Job Type</div>
          <div class="mx-2" (click)="sortField(tableColumns['col2'])">
            <i class="fa-solid fa-sort"></i>
          </div>
        </div>
        <div class="col-lg-4">
          <div class="d-flex">
            <div class="flex-grow-1">Site</div>
            <div class="mx-2" (click)="sortField(tableColumns['col3'])">
              <i class="fa-solid fa-sort"></i>
            </div>
          </div>
        </div>
        <div class="col-lg-1">
          <div class="d-flex">
            <div class="flex-grow-1">Docket No</div>
            <div class="mx-2" (click)="sortField(tableColumns['col4'])">
              <i class="fa-solid fa-sort"></i>
            </div>
          </div>
        </div>
        <div></div>
      </div>
    </div>
    @for (event of tabEventDataList; track event; let i = $index) {
      <div>
        <div
          class="row row-cols-1 row-cols-lg-5 align-items-center"
          [ngClass]="
            largeView
              ? 'border-bottom border-secondary-subtle py-3'
              : 'gt-card mb-3'
          "
        >
          <ng-template
            *ngTemplateOutlet="jobColumnsTemplateRef; context: { value: event }"
          ></ng-template>
          <div>
            <ng-template
              *ngTemplateOutlet="
                changeStatusTemplate;
                context: { value: event }
              "
            ></ng-template>
          </div>
        </div>
      </div>
    }
  }
  @if (totalRowsEvent) {
    <div class="mt-2">
      <gtapp-pagination-control
        [pageSize]="rowsEvent"
        [pageNum]="pageNumEvent"
        [previous]="previousEvent"
        [totalRows]="totalRowsEvent"
        (onChangePagination)="onChangePagination($event)"
      >
      </gtapp-pagination-control>
    </div>
  }
</ng-template>

<ng-template #invoiceListTemplateRef>
  <div class="row row-cols-1 row-cols-lg-4 col-lg-6 mb-3">
    <div class="col">
      <gtapp-auto-complete
        [data]="clientDropDownList"
        placeHolder="Select Client"
        searchKeyword="company_name"
        [itemTemplate]="clientTemplate"
        (inputChanged)="onClientSearch($event)"
        [initialValue]="selectedClient?.company_name"
        (selected)="onClientSelect($event)"
        [enableCloseOption]="true"
        inputId="clientLookupId"
        (fieldCleared)="editField('client')"
        (inputFocused)="inputFocused('client')"
      >
      </gtapp-auto-complete>
      <ng-template #clientTemplate let-item>
        <div>
          {{ item?.company_name }}
        </div>
      </ng-template>
    </div>

    @if (totalEventCount > 4) {
      <div class="col">
        <div class="input-group">
          <div class="form-floating">
            <input
              type="text"
              [(ngModel)]="eventSearchStr"
              placeholder="Filter Invoices"
              class="form-control"
              (input)="filterEvents()"
            />
            <label>Filter Invoices</label>
          </div>
          @if (eventSearchStr) {
            <span
              class="input-group-text"
              (click)="eventSearchStr = ''; filterEvents()"
            >
              <i class="fa-solid fa-xmark"></i>
            </span>
          }
        </div>
      </div>
    }
    <div class="col form-floating" (click)="openRangePicker()">
      <input
        class="form-control input-font-sm"
        readonly
        placeholder="Date Filter"
        [value]="dateRangeValue"
      />
      <label for="">Date Filter</label>
    </div>
    @if (hasAppliedAnyFilter) {
      <div class="col" [ngClass]="largeView ? '' : 'text-end'">
        <button
          (click)="resetAndFetchLatestData()"
          class="btn btn-lg btn-danger d-flex align-items-center gap-2"
        >
          <i class="fa-solid fa-xmark fa-2x"></i>
          Reset Filters
        </button>
      </div>
    }
  </div>

  @if (
    tabEventDataList?.length > 1 &&
    [uiTabs.tab1, uiTabs.tab2, uiTabs.tab4].includes(selectedTab)
  ) {
    <div>
      <div class="mb-3 d-flex gap-3 p-2 text-primary">
        <input
          class="form-check-input"
          type="checkbox"
          [checked]="allEventsSelected"
          (change)="selectAllEvents($event)"
          id="selectAllBox"
        />
        <label for="selectAllBox"
          >Select All [{{ tabEventDataList?.length }}]</label
        >
        @if (selectedEventIds?.length) {
          <span class="col">
            <ng-template *ngTemplateOutlet="changeStatusTemplate"></ng-template>
          </span>
        }
      </div>
    </div>
  }
  @if (tabEventDataList?.length) {
    <div class="p-lg-3">
      <div class="d-none d-lg-block">
        <div
          class="row row-cols-1 row-cols-lg-5 align-items-center text-secondary fw-semibold mb-3"
        >
          <div class="col-lg-2">
            <div class="d-flex m-0">
              <div>Invoiced</div>
              <div class="mx-2" (click)="sortField(tableColumns['col6'])">
                <i class="fa-solid fa-sort"></i>
              </div>
            </div>
          </div>
          <div class="d-flex">
            <div>Invoice ID</div>
          </div>
          <div class="col-lg-2">
            <div class="d-flex">
              <div>Client</div>
              <div class="mx-2" (click)="sortField(tableColumns['col5'])">
                <i class="fa-solid fa-sort"></i>
              </div>
            </div>
          </div>
          <div class="col-lg-2">
            <div class="d-flex">
              <div>Total (incl. GST)</div>
            </div>
          </div>
          <div></div>
        </div>
      </div>
      @for (event of tabEventDataList; track event; let i = $index) {
        <div>
          <div
            class="row row-cols-1 row-cols-lg-5 align-items-center"
            [ngClass]="
              largeView
                ? 'border-bottom border-secondary-subtle py-3'
                : 'gt-card mb-3'
            "
          >
            <div class="col-lg-2 row row-cols-2">
              @if (
                tabEventDataList?.length > 1 &&
                [uiTabs.tab1, uiTabs.tab2, uiTabs.tab4].includes(selectedTab)
              ) {
                <div
                  class="col order-2 order-lg-1 text-end text-lg-start ps-lg-3"
                >
                  <input
                    class="form-check-input"
                    type="checkbox"
                    [checked]="event?.selected"
                    (change)="markSelectedEvents(event)"
                  />
                </div>
              }
              <div class="enable-text-select order-1 order-lg-2">
                {{ event?.invoiced_at | customDate: "d MMM y" }}
              </div>
            </div>
            <div>
              {{ event?.invoice_num }}
            </div>
            <div class="col-lg-2">
              {{ event?.company?.company_name }}
            </div>
            <div class="col-lg-2 p-2 border-2">
              <div
                class="row row-cols-2"
                [ngClass]="largeView ? '' : 'text-end'"
              >
                <div class="col">
                  {{ event?.additional_info?.invoice_total_amount?.toFixed(2) }}
                </div>
              </div>
            </div>
            <div class="ps-lg-4">
              <ng-template
                *ngTemplateOutlet="
                  changeStatusTemplate;
                  context: { value: event }
                "
              ></ng-template>
            </div>
          </div>
        </div>
      }
    </div>
  }
  @if (totalRowsEvent) {
    <div class="mt-2">
      <gtapp-pagination-control
        [pageSize]="rowsEvent"
        [pageNum]="pageNumEvent"
        [previous]="previousEvent"
        [totalRows]="totalRowsEvent"
        (onChangePagination)="onChangePagination($event)"
      >
      </gtapp-pagination-control>
    </div>
  }
</ng-template>
<ng-template #changeStatusTemplate let-eventData="value">
  <div class="d-flex align-items-center gap-3">
    @if (eventData?.id && jobListView) {
      <button
        class="btn btn-sm btn-outline-secondary bg-white"
        (click)="
          jobListView
            ? openJobDetailPage(eventData)
            : getInvoiceAndGetJobs(eventData, invoicePricingTemplate)
        "
      >
        {{ jobListView ? "View Docket" : "Open Invoice" }}
      </button>
    }
    @switch (selectedTab) {
      @case (uiTabs.tab1) {
        @if (eventInvoiceStatusData?.[11]?.id) {
          @if (!eventData?.id && sameClientCheck && selectedEventIds) {
            <button
              (click)="
                sendMultipleDockets(
                  'job',
                  reportConfirmationTemplate,
                  selectedEventIds
                )
              "
              class="btn btn-sm btn-outline-secondary bg-white"
            >
              Send Dockets
            </button>
          }
          @if (sameClientCheck || eventData?.id) {
            <div
              data-bs-toggle="tooltip"
              data-bs-placement="top"
              title="Invoice"
            >
              <button
                class="btn btn-sm btn-outline-primary bg-white"
                (click)="
                  openInvoiceTemplate(
                    invoicePricingTemplate,
                    eventData?.id ? [eventData?.id] : selectedEventIds
                  )
                "
              >
                Create Invoice
              </button>
            </div>
          }
        }
        @if (eventInvoiceStatusData?.[12]?.id) {
          <div
            (click)="
              updateJobStatus(
                eventInvoiceStatusData?.[12],
                eventData?.id ? [eventData?.id] : selectedEventIds
              )
            "
          >
            <i
              class="fa-solid fa-ban fa-2x text-danger d-none"
              role="button"
            ></i>
            <button class="btn btn-sm btn-outline-danger bg-white">
              Do Not Invoice
            </button>
          </div>
        }
      }
      @case (uiTabs.tab2) {
        @if (!eventData?.id && sameClientCheck && selectedEventIds) {
          <button
            (click)="
              sendMultipleDockets(
                'invoice',
                reportConfirmationTemplate,
                selectedEventIds
              )
            "
            class="btn btn-sm btn-outline-secondary bg-white"
          >
            Send Dockets
          </button>
        }
        @if (eventData?.id) {
          <button
            (click)="printInvoice(eventData)"
            class="btn btn-sm btn-outline-primary bg-white"
          >
            View Invoice
          </button>
        }
        @if (eventInvoiceStatusData?.[13]?.id) {
          <button
            (click)="
              markAsReceived(
                eventInvoiceStatusData?.[13],
                eventData?.id ? [eventData?.id] : selectedEventIds
              )
            "
            class="btn btn-sm btn-outline-success bg-white"
          >
            Payment Received
          </button>
        }
      }
      @case (uiTabs.tab3) {
        @if (eventData?.id) {
          <button
            (click)="printInvoice(eventData)"
            class="btn btn-sm btn-outline-success bg-white"
          >
            View Invoice
          </button>
        }
      }
      @case (uiTabs.tab4) {
        @if (eventInvoiceStatusData?.[10]?.id) {
          <button
            class="btn btn-sm btn-primary"
            (click)="
              updateJobStatus(
                eventInvoiceStatusData?.[10],
                eventData?.id ? [eventData?.id] : selectedEventIds
              )
            "
          >
            Ready for Invoicing
          </button>
        }
      }
    }
  </div>
</ng-template>

<ng-template #donInvoiceTemplate let-donInvoiceTemplate="dialogRef">
  <div class="dialog-box card">
    <div class="card-header">
      Do Not Invoice Reason
      <span class="float-end" (click)="donInvoiceTemplate.close()">
        <i class="fa-solid fa-xmark"></i>
      </span>
    </div>
    <div>
      <div class="form-group input-group mb-3">
        <textarea
          class="form-control"
          placeholder="[Limited to 160 characters]"
          cols="20"
          rows="4"
          wrap="hard"
          maxlength="160"
          type="text"
          [(ngModel)]="dNotInvoiceReason"
          id="dNotInvoiceReasonField"
        ></textarea>
        @if (dNotInvoiceReason) {
          <span
            class="input-group-text"
            (click)="
              dNotInvoiceReason = '';
              clearAndFocusTextBox('dNotInvoiceReasonField')
            "
          >
            <i class="fa-solid fa-xmark"></i>
          </span>
        }
      </div>

      <div class="row row-cols-2 my-2">
        <div class="col">
          <button
            class="btn btn-dark btn-lg w-100"
            (click)="donInvoiceTemplate.close()"
          >
            Cancel
          </button>
        </div>
        <div class="col">
          <button
            class="btn btn-primary btn-lg w-100"
            [disabled]="!dNotInvoiceReason"
            (click)="donInvoiceTemplate.close(); donotInvoiceEvents()"
          >
            Update
          </button>
        </div>
      </div>
    </div>
  </div></ng-template
>

@if (!totalEventCount) {
  <div class="p-3">No records</div>
}

<ng-template
  #invoicePricingTemplate
  let-invoicePricingTemplateRef="dialogRef"
  let-data
>
  <div class="dialog-box invoice-dialog card">
    <div class="card-header">
      Invoice

      <span
        class="float-end"
        (click)="
          invoicePricingTemplateRef.close(); updateInvoiceItems(data?.eventData)
        "
      >
        <i class="fa-solid fa-xmark"></i>
      </span>
    </div>
    <div class="">
      <div class="row row-cols-2 row-cols-xl-3 mb-2">
        <div class="col-12">
          <dl>
            <dt class="text-body-emphasis">Client</dt>
            <dd class="fw-semibold fs-5">{{ data?.company_name }}</dd>
          </dl>
        </div>
        <div class="col">
          <div class="form-floating">
            <input
              class="form-control"
              type="date"
              [(ngModel)]="invoiceDate"
              [class.is-invalid]="!invoiceDate"
              placeholder="Invoice Date"
              required
              [disabled]="[uiTabs.tab2, uiTabs.tab3].includes(selectedTab)"
            />
            <label for="username">Invoice Date</label>
          </div>

          @if (
            backupInvoiceDate &&
            backupInvoiceDate != invoiceDate &&
            invoiceDate &&
            data?.eventData?.id
          ) {
            <div class="row row-cols-2 pt-2">
              <div class="col">
                <button
                  class="btn btn-dark w-100"
                  (click)="invoiceDate = backupInvoiceDate"
                >
                  Cancel
                </button>
              </div>
              <div class="col">
                <button
                  class="btn w-100 btn-success"
                  (click)="updateInvoiceDate(data?.eventData?.id)"
                >
                  Update
                </button>
              </div>
            </div>
          }
        </div>
        <div class="col">
          <div class="form-floating">
            <input
              class="form-control"
              type="text"
              [(ngModel)]="invoiceNum"
              [class.is-invalid]="!invoiceNum"
              placeholder="Invoice ID"
              autocorrect="off"
              autocapitalize="off"
              required
              maxlength="24"
              [disabled]="[uiTabs.tab2, uiTabs.tab3].includes(selectedTab)"
            />
            <label for="username">Invoice ID</label>
          </div>
          @if (
            backupInvoiceNum &&
            backupInvoiceNum != invoiceNum &&
            invoiceNum &&
            data?.eventData?.id
          ) {
            <div class="row row-cols-2 pt-2">
              <div class="col">
                <button
                  class="btn btn-dark w-100"
                  (click)="invoiceNum = backupInvoiceNum"
                >
                  Cancel
                </button>
              </div>
              <div class="col">
                <button
                  class="btn w-100 btn-success"
                  (click)="updateInvoiceId(data?.eventData?.id)"
                >
                  Update
                </button>
              </div>
            </div>
          }
        </div>
      </div>

      <div id="invoiceItemsContainer" class="mb-3">
        @for (job of selectedEvents; track job; let i = $index) {
          <div class="my-3">
            <div
              class="row row-cols-3 row-cols-xl-6 bg-body-secondary rounded p-2 mx-1"
            >
              <div class="col-4 col-xl-1">
                <div class="d-flex">
                  <div>{{ i + 1 }}.</div>
                  <div class="flex-grow-1 ps-2 text-break">
                    {{ job?.job_key }}
                    @if (job?.ext_job_id) {
                      <div class="small-font">[{{ job?.ext_job_id }}]</div>
                    }
                  </div>
                </div>
              </div>
              <div class="col-8">
                {{ job?.job_type }}
                @if (job?.response_type) {
                  <div class="small-font fw-semibold">
                    [{{ job?.response_type }}]
                  </div>
                }
                @if (
                  onsiteDurationDict?.[job?.id] &&
                  onsiteDurationDict?.[job?.id] > 0
                ) {
                  <div>
                    <span class="text-secondary small"> Time Onsite: </span>
                    <span>
                      @if (onsiteDurationDict?.[job?.id] > 20) {
                        <span class="text-danger">
                          {{ onsiteDurationDict?.[job?.id] }}
                          [+{{ onsiteDurationDict?.[job?.id] - 20 }} over]</span
                        >
                      } @else {
                        {{ onsiteDurationDict?.[job?.id] }}
                      }
                    </span>
                  </div>
                }
              </div>
              <div class="col-12 col-xl-3 my-sm-4 my-xl-2 ms-2 ms-xl-0">
                <div class="fw-semibold text-break">
                  {{ job?.site?.company_name }}
                </div>
                @if (job?.shift?.duration) {
                  <div class="small">
                    {{
                      job?.shift?.start_datetime | customDate: "d MMM y HH:mm"
                    }}
                    -
                    {{ job?.shift?.end_datetime | customDate: "HH:mm" }}
                    <span class="fw-semibold">{{ job?.shift?.duration }}</span>
                  </div>
                }
              </div>
              <div class="col-6 ps-3">
                <div class="form-floating">
                  <input
                    class="form-control"
                    type="tel"
                    inputmode="numeric"
                    pattern="[0-9]*"
                    [(ngModel)]="job.sale_amount"
                    autocorrect="off"
                    autocapitalize="off"
                    autocomplete="off"
                    required
                    pattern="^\d*(\.\d{0,4})?$"
                    (input)="modifyJobAmount(job, 'sale')"
                    [disabled]="
                      [uiTabs.tab2, uiTabs.tab3].includes(selectedTab)
                    "
                    size="5"
                    maxlength="5"
                    placeholder="0"
                    id="saleAmount"
                    (focus)="prefilOptionFocused = 'sale' + i"
                  />
                  <label for="saleAmount">Excl. GST</label>
                </div>
                @if (
                  prefilOptionFocused == "sale" + i &&
                  job?.sale_amount != job?.backupData?.sale_amount &&
                  (selectedEvents
                    | misc: "checkSameJobTypeExists" : job?.job_type_id)
                ) {
                  <div
                    class="border text-dark bg-white rounded p-1 small-font text-center hover mt-2"
                    role="button"
                    (click)="conditionalPrefillData(job)"
                  >
                    Update All
                    <span class="fw-semibold">{{ job?.job_type }}</span>
                  </div>
                }
              </div>
              <div class="col-6 pe-3">
                <div class="form-floating">
                  <input
                    class="form-control"
                    [(ngModel)]="job.total_amount"
                    autocorrect="off"
                    autocapitalize="off"
                    autocomplete="off"
                    required
                    pattern="^\d*(\.\d{0,4})?$"
                    type="tel"
                    inputmode="numeric"
                    pattern="[0-9]*"
                    (input)="modifyJobAmount(job, 'total')"
                    [disabled]="
                      [uiTabs.tab2, uiTabs.tab3].includes(selectedTab)
                    "
                    size="5"
                    maxlength="5"
                    placeholder="0"
                    id="totalAmount"
                    (focus)="prefilOptionFocused = 'total' + i"
                  />
                  <label for="totalAmount">Incl. GST</label>
                </div>
                @if (
                  prefilOptionFocused == "total" + i &&
                  job?.sale_amount != job?.backupData?.sale_amount &&
                  (selectedEvents
                    | misc: "checkSameJobTypeExists" : job?.job_type_id)
                ) {
                  <div
                    class="border text-dark bg-white rounded p-1 small-font text-center hover mt-2"
                    role="button"
                    (click)="conditionalPrefillData(job)"
                  >
                    Update All
                    <span class="fw-semibold">{{ job?.job_type }}</span>
                  </div>
                }
              </div>
              <!-- <div
                                            class="col-12 pt-3 pt-xl-0"
                                            *ngIf="[uiTabs.tab2].includes(selectedTab)"
                                            >
                                            @if( job?.invoice_job_id){
                                              @if((backUpInvoiceDataList[i]?.sale_amount !==job?.sale_amount )){
                                                <div class="d-flex align-items-center gap-2 justify-content-end">
                                                  @if( job?.invoice_job_id){
                                                    <button
                                                      class="btn btn-success btn-sm"
                  (click)="
                    updateInvoiceIndividualPricing(
                      job,
                      data,

                      i
                    )
                  "
                                                      >
                                                      Save</button
                                                      >}
                                                    </div>
                                                    }@else {
                                                    <div class="d-flex align-items-center gap-2 justify-content-end">
                                                      <div>
                                                        <button
                                                          class="btn btn-outline-secondary btn-sm bg-white"
                                                          (click)="openJobDetailPage(job)"
                                                          >
                                                          View Docket
                                                        </button>
                                                      </div>
                                                      <div>
                                                        <button
                                                          *ngIf="selectedEvents?.length > 1"
                                                          class="btn btn-outline-danger btn-sm bg-white"
                    (click)="
                      voidInvoice(
                        data?.eventData?.id,
                        job?.invoice_job_id,
                        selectedEvents,
                        i
                      )
                    "
                                                          >
                                                          <i class="fa-solid fa-trash"></i>
                                                        </button>
                                                      </div>
                                                    </div>
                                                    }}@else {
                                                    <div class="d-flex align-items-center gap-2 justify-content-end">
                                                      <div>
                                                        <button
                                                          class="btn btn-outline-secondary btn-sm bg-white"
                                                          (click)="openJobDetailPage(job)"
                                                          >
                                                          View Docket
                                                        </button>
                                                      </div>
                                                      <div>
                                                        <button
                                                          class="btn btn-outline-danger btn-sm bg-white"
                                                          (click)="selectedEvents?.splice(i, 1)"
                                                          >
                                                          <i class="fa-solid fa-trash"></i>
                                                        </button>
                                                      </div>
                                                    </div>
                                                  }
                                                </div> -->
              @if (
                [uiTabs.tab3, uiTabs.tab1, uiTabs.tab2].includes(selectedTab)
              ) {
                <div class="col-12 pt-3 pt-xl-0">
                  <div
                    class="d-flex align-items-center gap-2 justify-content-end"
                  >
                    <div>
                      <button
                        class="btn btn-outline-secondary btn-sm bg-white"
                        (click)="openJobDetailPage(job)"
                      >
                        View Docket
                      </button>
                    </div>
                    @if ([uiTabs.tab1].includes(selectedTab)) {
                      <div>
                        @if (selectedEvents?.length > 1) {
                          <button
                            class="btn btn-outline-danger btn-sm bg-white"
                            (click)="selectedEvents?.splice(i, 1)"
                          >
                            <i class="fa-solid fa-trash"></i>
                          </button>
                        }
                      </div>
                    }
                  </div>
                </div>
              }
            </div>
          </div>
        }
        @for (miscItem of additionalLineItems; track miscItem; let i = $index) {
          <div class="mb-3">
            <div
              class="row row-cols-3 row-cols-xl-6 bg-body-secondary rounded p-2 mx-1"
            >
              <div class="col-4 col-xl-1">
                <div class="d-flex">
                  <div>{{ i + 1 + selectedEvents?.length }}.</div>
                </div>
              </div>
              <div class="col-12 col-xl-5 my-2 pe-3">
                @if (miscItem?.editValue) {
                  <div class="form-floating">
                    <input
                      class="form-control"
                      type="text"
                      [(ngModel)]="miscItem.itemName"
                      autocorrect="off"
                      autocapitalize="off"
                      (blur)="miscItem.editValue = false"
                      required
                      [disabled]="
                        [uiTabs.tab2, uiTabs.tab3].includes(selectedTab)
                      "
                      id="lineItemName"
                    />
                    <label for="lineItemName">Charge Item</label>
                  </div>
                } @else {
                  <span
                    [class.link-edit]="selectedTab === uiTabs.tab1"
                    (click)="
                      selectedTab === uiTabs.tab1
                        ? (miscItem.editValue = true)
                        : null
                    "
                  >
                    {{ miscItem?.itemName }}
                  </span>
                }
              </div>
              <div class="col-6 ps-3">
                <div class="form-floating">
                  <input
                    class="form-control"
                    type="tel"
                    inputmode="numeric"
                    pattern="[0-9]*"
                    [(ngModel)]="miscItem.sale_amount"
                    autocorrect="off"
                    autocapitalize="off"
                    autocomplete="off"
                    required
                    pattern="^\d*(\.\d{0,4})?$"
                    (input)="modifyJobAmount(miscItem, 'sale')"
                    [disabled]="
                      [uiTabs.tab2, uiTabs.tab3].includes(selectedTab)
                    "
                    size="5"
                    maxlength="5"
                    placeholder="0"
                    id="saleAmount"
                  />
                  <label for="saleAmount">Excl. GST</label>
                </div>
              </div>
              <div class="col-6 pe-3">
                <div class="form-floating">
                  <input
                    class="form-control"
                    [(ngModel)]="miscItem.total_amount"
                    autocorrect="off"
                    autocapitalize="off"
                    autocomplete="off"
                    required
                    pattern="^\d*(\.\d{0,4})?$"
                    type="tel"
                    inputmode="numeric"
                    pattern="[0-9]*"
                    (input)="modifyJobAmount(miscItem, 'total')"
                    [disabled]="
                      [uiTabs.tab2, uiTabs.tab3].includes(selectedTab)
                    "
                    size="5"
                    maxlength="5"
                    placeholder="0"
                    id="totalAmount"
                  />
                  <label for="totalAmount">Incl. GST</label>
                </div>
              </div>
              @if ([uiTabs.tab2, uiTabs.tab1].includes(selectedTab)) {
                <div class="col-12 pt-3 pt-xl-0">
                  @if ([uiTabs.tab2].includes(selectedTab)) {
                    <div class="col-12 pt-3 pt-xl-0">
                      @if (miscItem?.id) {
                        @if (
                          backUpAdditionalLineItems[i]?.sale_amount !==
                            miscItem?.sale_amount ||
                          (backUpAdditionalLineItems[i]?.itemName !==
                            miscItem?.itemName &&
                            miscItem?.itemName)
                        ) {
                          <div
                            class="d-flex align-items-center gap-2 justify-content-end"
                          >
                            <button
                              class="btn btn-success btn-sm"
                              (click)="
                                updateLineItemIndividualPricing(
                                  miscItem,
                                  data,
                                  i
                                )
                              "
                            >
                              Save
                            </button>
                          </div>
                        } @else {
                          <div
                            class="d-flex align-items-center gap-2 justify-content-end"
                          >
                            <div>
                              <button
                                class="btn btn-outline-danger btn-sm bg-white"
                                (click)="
                                  voidLineItem(
                                    data?.eventData?.id,
                                    miscItem?.id,
                                    i
                                  );
                                  refreshCustomLineItemList()
                                "
                              >
                                <i class="fa-solid fa-trash"></i>
                              </button>
                            </div>
                          </div>
                        }
                      } @else {
                        <div
                          class="d-flex align-items-center gap-2 justify-content-end"
                        >
                          <button
                            class="btn btn-outline-danger btn-sm bg-white"
                            (click)="
                              additionalLineItems?.splice(i, 1);
                              refreshCustomLineItemList()
                            "
                          >
                            <i class="fa-solid fa-trash"></i>
                          </button>
                        </div>
                      }
                    </div>
                  }
                  @if ([uiTabs.tab1].includes(selectedTab)) {
                    <div
                      class="d-flex align-items-center gap-2 justify-content-end"
                    >
                      <button
                        class="btn btn-outline-danger btn-sm bg-white"
                        (click)="
                          additionalLineItems?.splice(i, 1);
                          refreshCustomLineItemList()
                        "
                      >
                        <i class="fa-solid fa-trash"></i>
                      </button>
                    </div>
                  }
                </div>
              }
            </div>
          </div>
        }
      </div>
      @if ([uiTabs.tab1].includes(selectedTab)) {
        <div class="mb-3">
          <div
            class="row bg-body-secondary rounded p-2 mx-1"
            id="btnAddInvoiceItem"
          >
            <div
              class="col text-center m-auto"
              (click)="openAddItemTemplate(addItemCheckTemplateRef, data)"
              role="button"
            >
              <i class="fa-solid fa-plus fa-2x text-secondary"></i>
            </div>
          </div>
        </div>
      }

      <div class="fw-semibold text-center">
        {{ selectedEvents?.length + additionalLineItems?.length }}
        <span class="fw-normal"> Items</span>
      </div>

      @if ([uiTabs.tab1].includes(selectedTab) && filteredLineItems?.length) {
        <div class="d-flex gap-2 justify-content-end mb-2">
          <div
            class="border border-1 rounded p-1 d-flex gap-1 align-items-center"
          >
            <dt class="p-2 small fw-semibold">Quick Add</dt>
            @for (
              existItem of filteredLineItems?.slice(0, 3);
              track existItem
            ) {
              <button
                class="btn btn-outline-primary bg-white"
                (click)="addExistingLineItem(existItem)"
              >
                + {{ existItem }}
              </button>
            }
          </div>
        </div>
      }
      @if (
        selectedEvents?.[0].sale_amount ||
        selectedEvents?.[0].tax_amount ||
        additionalLineItems?.[0]?.sale_amount ||
        additionalLineItems?.[0]?.tax_amount
      ) {
        <div class="py-1 offset-2 offset-lg-10">
          <div class="row row-cols-2 text-end">
            <div class="col p-2 small">Sub-Total</div>
            <div class="col p-2">
              {{ regionCurrencySymbol
              }}{{ getTotalInvoiceAmount("sale") | number: "1.2-2" }}
            </div>
            <div class="col p-2 small">GST</div>
            <!--Tax=0.0909×Total Amount-->
            <div class="col p-2">
              {{ regionCurrencySymbol
              }}{{ getTotalInvoiceAmount("tax") | number: "1.2-2" }}
            </div>
            <div class="col p-2">Total</div>
            <div class="col p-2 fw-semibold">
              {{ regionCurrencySymbol
              }}{{ getTotalInvoiceAmount("total") | number: "1.2-2" }}
            </div>
          </div>
        </div>
      }
    </div>
    <ng-container>
      <div class="d-flex gap-2 justify-content-between pt-4 flex-wrap">
        <div class="d-flex gap-2">
          @if (data?.eventData?.id && selectedTab === uiTabs.tab2) {
            <button
              class="btn btn-lg btn-danger w-100"
              (click)="voidInvoice(data?.eventData?.id)"
            >
              Void Invoice
            </button>
          }
          @if (
            data?.eventData?.id &&
            [uiTabs.tab2, uiTabs.tab3].includes(selectedTab)
          ) {
            <button
              class="btn btn-lg btn-success w-100"
              (click)="printInvoice(data?.eventData)"
            >
              Print Invoice
            </button>
          }
        </div>
        <div class="d-flex gap-2">
          @if (
            (data?.eventData?.id &&
              backUpInvoiceDataList?.length === selectedEvents?.length &&
              backUpAdditionalLineItems?.length ===
                additionalLineItems?.length) ||
            (selectedEventIds?.length && !data?.eventData?.id)
          ) {
            <button
              class="btn btn-lg btn-outline-secondary bg-white w-100"
              (click)="
                sendMultipleDockets(
                  data?.eventData?.id ? 'invoice' : 'job',
                  reportConfirmationTemplate,
                  data?.eventData?.id ? [data?.eventData?.id] : selectedEventIds
                )
              "
            >
              Send Dockets
            </button>
          }
          @if (selectedTab == uiTabs.tab1) {
            <button
              class="btn btn-lg btn-primary w-100"
              (click)="createNewInvoice()"
              [disabled]="!invoiceDate || !invoiceNum"
            >
              Create Invoice
            </button>
          }
          @if (selectedTab == uiTabs.tab2) {
            @if (
              backUpInvoiceDataList?.length === selectedEvents?.length &&
              backUpAdditionalLineItems?.length === additionalLineItems?.length
            ) {
              <button
                class="btn w-100 btn-lg btn-success w-100"
                (click)="
                  updateInvoiceStatus(
                    eventInvoiceStatusData?.[13],
                    data?.eventData?.id
                      ? [data?.eventData?.id]
                      : selectedEventIds
                  )
                "
              >
                Invoice Paid
              </button>
            } @else {
              <button
                [disabled]="!data?.eventData?.id"
                class="btn w-100 btn-lg btn-primary w-100"
                (click)="updateInvoiceItems(data?.eventData, true)"
              >
                Update Invoice
              </button>
            }
          }
          @if (selectedTab == uiTabs.tab3) {
            <button
              class="btn btn-lg btn-danger w-100"
              (click)="
                updateInvoiceStatus(
                  eventInvoiceStatusData?.[11],
                  data?.eventData?.id ? [data?.eventData?.id] : selectedEventIds
                )
              "
            >
              Invoice Not Paid
            </button>
          }
        </div>
      </div>
    </ng-container>
  </div>
</ng-template>

<ng-template
  #jobColumnsTemplateRef
  let-event="value"
  let-addMoreJobs="addMoreJobs"
>
  <div class="col-lg-2 row row-cols-2">
    @if (
      (addMoreJobs
        ? [uiTabs.tab1, uiTabs.tab2, uiTabs.tab4, uiTabs.tab3]
        : [uiTabs.tab1, uiTabs.tab2, uiTabs.tab4]
      ).includes(selectedTab)
    ) {
      <div class="col order-2 order-lg-1 text-end text-lg-start ps-lg-3">
        <input
          class="form-check-input"
          type="checkbox"
          [checked]="event?.selected"
          (change)="
            addMoreJobs ? selectJobsToInvoice(event) : markSelectedEvents(event)
          "
        />
      </div>
    }

    <div class="enable-text-select order-1 order-lg-2">
      {{ event?.report_date | customDate: "d MMM y" }}
    </div>
  </div>
  <div>
    <div>
      <span class="enable-text-select">
        {{ event?.job_type }}
      </span>

      @if (event?.response_type) {
        <div class="fw-semibold small`">
          [<span class="enable-text-select">{{ event?.response_type }}</span
          >]
        </div>
      }
      @if (event?.service_type) {
        <div class="fw-semibold small`">
          [<span class="enable-text-select">{{ event?.service_type }}</span
          >]
        </div>
      }
      @if (
        onsiteDurationDict?.[event?.id] && onsiteDurationDict?.[event?.id] > 0
      ) {
        <div>
          <span class="text-secondary small"> Onsite (mins): </span>
          <span>
            @if (onsiteDurationDict?.[event?.id] > 20) {
              <span class="text-danger">
                {{ onsiteDurationDict?.[event?.id] }}
                [{{ onsiteDurationDict?.[event?.id] - 20 }} min over]</span
              >
            } @else {
              <span class="fw-semibold">
                {{ onsiteDurationDict?.[event?.id] }}
              </span>
            }
          </span>
        </div>
      }
      @if (event?.shift?.duration) {
        <div class="small">
          {{ event?.shift?.start_datetime | customDate: "d MMM y HH:mm" }}
          -
          {{ event?.shift?.end_datetime | customDate: "HH:mm" }}
          <span class="fw-semibold"> {{ event?.shift?.duration }}</span>
        </div>
      }
    </div>
  </div>
  <div class="col-lg-4">
    <div class="fw-semibold">
      <span class="enable-text-select">
        {{ event?.site?.company_name }}
      </span>
      <span class="small-font enable-text-select"
        >[{{ event?.company?.company_name }}]</span
      >
    </div>
    <div class="small-font enable-text-select">
      {{ event?.site?.address }}
    </div>
  </div>
  <div class="col-lg-1">
    <div>
      <span class="enable-text-select text-break">
        {{ event?.job_key }}
      </span>
      @if (event?.ext_job_id) {
        <div class="fw-semibold small enable-text-select">
          {{ event?.ext_job_id }}
        </div>
      }
    </div>
  </div>
</ng-template>

<ng-template
  #addMoreJobsToInvoiceTemplateRef
  let-addMoreJobsToInvoiceTemplateRef="dialogRef"
  let-data
>
  <div class="dialog-box invoice-dialog card">
    <div class="card-header">
      Add Jobs to Invoice
      <span class="float-end" (click)="addMoreJobsToInvoiceTemplateRef.close()">
        <i class="fa-solid fa-xmark"></i>
      </span>
    </div>
    <div class="row row-cols-2">
      <!-- <div class="col">
                                                      <gtapp-auto-complete
                                                        [data]="siteDropDownList"
                                                        placeHolder="Select Site"
                                                        searchKeyword="company_name"
                                                        [initialValue]="selectedSite?.company_name"
                                                        [itemTemplate]="siteTemplate"
                                                        (inputChanged)="onSiteSearch($event)"
                                                        (selected)="onSiteSelect($event)"
                                                        [inputId]="'siteId'"
                                                        [enableCloseOption]="true"
                                                        (fieldCleared)="editField('site')"
                                                        >
                                                      </gtapp-auto-complete>

                                                      <ng-template #siteTemplate let-item>
                                                        <div>
                                                          <div class="fw-medium">
                                                            {{ item?.company_name }}
                                                          </div>

                                                          <div class="small-font text-secondary">
                                                            {{ item?.address?.full_address }}
                                                          </div>
                                                        </div>
                                                      </ng-template>
                                                    </div> -->
      @if (totalAddMoreJobsCount > 4) {
        <div class="col">
          <div class="input-group">
            <div class="form-floating">
              <input
                type="text"
                [(ngModel)]="addMoreJobsSearchStr"
                placeholder="Filter Jobs"
                class="form-control"
                (input)="filterAddJobsToInvoice(data?.companyId)"
              />
              <label>Filter Jobs</label>
            </div>
            @if (addMoreJobsSearchStr) {
              <span
                class="input-group-text"
                (click)="
                  addMoreJobsSearchStr = '';
                  filterAddJobsToInvoice(data?.companyId)
                "
              >
                <i class="fa-solid fa-xmark"></i>
              </span>
            }
          </div>
        </div>
      }
      <div
        class="col form-floating"
        (click)="openRangePicker('addMore', data?.companyId)"
      >
        <input
          class="form-control input-font-sm"
          readonly
          placeholder="Date Filter"
          [value]="dateRangeValue"
        />
        <label for="">Date Filter</label>
      </div>
    </div>
    @if (selectedJobsToAddToInvoice?.length) {
      <div class="text-end my-2">
        <button
          class="btn btn-md btn-success"
          (click)="addMoreJobsToInvoiceTemplateRef.close(true); prefillData()"
        >
          Add Jobs To Invoice
        </button>
      </div>
    }
    <div class="overflow-45vh">
      @for (event of addMoreJobDataList; track event; let i = $index) {
        <div>
          <div
            class="row row-cols-1 row-cols-lg-4 align-items-center"
            [ngClass]="
              largeView
                ? 'border-bottom border-secondary-subtle py-3'
                : 'gt-card mb-3'
            "
          >
            <ng-template
              *ngTemplateOutlet="
                jobColumnsTemplateRef;
                context: { value: event, addMoreJobs: true }
              "
            ></ng-template>
          </div>
        </div>
      }
    </div>
    @if (totalRowsAddMoreJobs) {
      <div class="mt-2">
        <gtapp-pagination-control
          [pageSize]="rowsAddMoreJobs"
          [pageNum]="pageNumAddMoreJobs"
          [previous]="previousAddMoreJobs"
          [totalRows]="totalRowsAddMoreJobs"
          (onChangePagination)="
            onChangePaginationAddMoreJobs($event, data?.companyId)
          "
        >
        </gtapp-pagination-control>
      </div>
    }
  </div>
</ng-template>
<ng-template
  #addLineItemTemplateRef
  let-addLineItemTemplateRef="dialogRef"
  let-data
>
  <div class="dialog-box card">
    <div class="card-header">
      Add Charge
      <span class="float-end" (click)="addLineItemTemplateRef.close(false)">
        <i class="fa-solid fa-xmark"></i>
      </span>
    </div>
    <div class="row row-cols-1">
      @for (item of data; track $index) {
        <div class="d-flex mb-2">
          <div class="flex-grow-1 me-2">
            <div class="input-group">
              <div class="form-floating">
                <input
                  type="text"
                  [(ngModel)]="item.itemName"
                  placeholder="Description"
                  class="form-control"
                  [id]="'fieldName' + $index"
                />
                <label>Description</label>
              </div>
              @if (item?.itemName) {
                <span class="input-group-text" (click)="item.itemName = ''">
                  <i class="fa-solid fa-xmark"></i>
                </span>
              }
            </div>
          </div>
          @if (data?.length > 1) {
            <div>
              <button
                class="btn btn-outline-danger bg-white btn-lg"
                (click)="data?.splice($index, 1)"
              >
                <i class="fa-solid fa-trash"></i>
              </button>
            </div>
          }
        </div>
      }
    </div>

    <div class="row row-cols-2 my-2">
      <div class="col">
        <button
          class="btn btn-dark btn-lg w-100"
          (click)="addLineItemTemplateRef.close(false)"
        >
          Clear
        </button>
      </div>
      <div class="col">
        <button
          [disabled]="!data[data?.length - 1]?.itemName"
          class="btn btn-primary btn-lg w-100"
          (click)="addLineItemTemplateRef.close(data)"
        >
          Submit
        </button>
      </div>
    </div>
  </div>
</ng-template>
<ng-template #addItemCheckTemplateRef let-addItemCheckTemplateRef="dialogRef">
  <div class="dialog-box card">
    <div class="card-header">
      Select Item
      <span class="float-end" (click)="addItemCheckTemplateRef.close(false)">
        <i class="fa-2x fa-solid fa-xmark"></i>
      </span>
    </div>
    <div class="my-3">
      <button
        class="btn btn-primary w-100 btn-lg"
        (click)="
          addItemCheckTemplateRef.close({
            _type: 'job',
            template: addMoreJobsToInvoiceTemplateRef,
          })
        "
      >
        + Add Completed Job
      </button>
    </div>
    <div class="my-3">
      <button
        class="btn btn-primary w-100 btn-lg"
        (click)="
          addItemCheckTemplateRef.close({
            _type: 'charge',
            template: addLineItemTemplateRef,
          })
        "
      >
        + Add Custom Charge
      </button>
    </div>
  </div>
</ng-template>
<!-- send report confirmation  DIALOG -->
<ng-template
  #reportConfirmationTemplate
  let-reportConfirmationTemplate="dialogRef"
  let-data
>
  <div class="dialog-box card">
    <div class="card-header">
      Recipients
      <span class="float-end" (click)="reportConfirmationTemplate.close(false)">
        <i class="fa-2x fa-solid fa-xmark"></i>
      </span>
    </div>

    @if (reportRecipientList?.length) {
      <table class="table">
        <tbody>
          @for (contact of reportRecipientList; track contact; let i = $index) {
            <tr>
              <td class="border-0">
                <div class="form-check">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    [checked]="!contact.isSnubbed"
                    (change)="selectUnselectRecipients(contact)"
                    id="check-{{ contact.id }}-{{ i }}"
                  />
                  <label
                    class="form-check-label"
                    for="check-{{ contact.id }}-{{ i }}"
                  >
                    {{ contact?.full_name }}
                    @if (contact?.is_site_contact) {
                      <span class="small-font text-secondary"
                        >[Site Contact]</span
                      >
                    }
                    <div class="small-font">
                      {{ contact?.email }}
                    </div>
                  </label>
                </div>
              </td>
            </tr>
          }
        </tbody>
      </table>
    } @else {
      <div class="mb-2 alert alert-danger">
        There are no recipients configured for this site
      </div>
    }
    @if (selectedReportRecipientList?.length) {
      <dt class="text-end me-4 pt-2">
        Total Recipients Selected:
        <span class="fw-semibold fs-6">{{
          selectedReportRecipientList?.length
        }}</span>
      </dt>
    }

    <div class="row row-cols-2 pt-4">
      <div class="col">
        <button
          class="btn btn-lg btn-secondary w-100"
          type="button"
          (click)="reportConfirmationTemplate.close(false)"
        >
          Back
        </button>
      </div>
      <div class="col">
        <button
          class="btn btn-lg w-100 btn-success"
          type="button"
          (click)="reportConfirmationTemplate.close(true)"
          [disabled]="!selectedReportRecipientList?.length"
        >
          Send Report
        </button>
      </div>
    </div>
  </div>
</ng-template>
